'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadioButton = require('./components/RadioButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-radio-button/lib/index.js
// module id = 895
// module chunks = 0